var keyPairUnitConfig = {
  column: 3,
  layout: 'horizontal',
  showDivider: false,
  valueAsBold: true,
  isReverse: false
};
export default {
  light: keyPairUnitConfig,
  dark: keyPairUnitConfig,
  white: keyPairUnitConfig
};